import React, { useCallback } from "react";
import { connect } from "react-redux";

import { isNotEmpty } from "@mapmycustomers/shared/util/assert";

import { getFunnels, getFunnelStages } from "@app/store/deal";
import { RootState } from "@app/store/rootReducer";

import FrequencySelector from "../FrequencySelector";
import FrequencyIntervalValue from "../type/FrequencyIntervalValue";

interface FrequencyIntervalEditorProps {
  disabled?: boolean;
  onChange: (value?: FrequencyIntervalValue) => void;
  showActivityTypes?: boolean;
  value?: FrequencyIntervalValue;
}

const FrequencyIntervalEditor: React.FC<FrequencyIntervalEditorProps> = ({
  disabled,
  onChange,
  showActivityTypes,
  value,
}) => {
  const handleChange = useCallback(
    (value: FrequencyIntervalValue) => {
      onChange(isNotEmpty(value.cadenceInterval) ? value : undefined);
    },
    [onChange]
  );

  return (
    <FrequencySelector
      crmActivityTypeIds={value?.crmActivityTypeId}
      disabled={disabled}
      frequencyIntervalValue={value?.cadenceInterval ?? undefined}
      onChange={handleChange}
      showActivityTypes={showActivityTypes}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  funnels: getFunnels(state),
  funnelStages: getFunnelStages(state),
});

export default connect(mapStateToProps)(FrequencyIntervalEditor);
